import React from "react";
import SEO from "../common/SEO";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import FormTwo from "../component/contact/FormTwo";
import SectionTitle from "../elements/section-title/SectionTitle";
import ContactLocation from "../component/contact/ContactLocation";
import HeaderFour from "../common/header/HeaderFour";
import { useSelector } from "react-redux";
import { media_url } from "../hooks/useBlog";

const Contact = () => {
  const { currentCustomer } = useSelector((state) => state.store);
  return (
    <>
      <SEO
        title="Contacto"
        description={"Contacta con nosotros" + " " + currentCustomer?.name}
        image={media_url(currentCustomer?.logo)}
        keyword={
          "Contacto, Teléfono, Correo Electrónico, Ubicación, Oficina, " +
          currentCustomer?.name
        }
      />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Contacto" page="Contacto" />

        <div className="section section-padding">
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-6">
                <div className="contact-form-box shadow-box mb--30">
                  <h3 className="title">Contacta con nosotros</h3>
                  <FormTwo />
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 offset-xl-1">
                <div className="contact-info mb--100 mb_md--30 mt_md--0 mt--150">
                  <h4 className="title">Teléfono</h4>
                  <p>
                    Nuestro servicio de atención al cliente está disponible de
                    lunes a viernes, de 8:00 a 16:00
                  </p>
                  <h4 className="phone-number">
                    <a href={`tel:${currentCustomer?.phone}`}>
                      {currentCustomer?.phone}
                    </a>
                  </h4>
                </div>
                <div className="contact-info mb--30">
                  <h4 className="title">Correo Electrónico</h4>
                  <p>
                    Nuestro equipo de soporte se pondrá en contacto contigo en
                    un plazo de 48 horas durante el horario laboral.
                  </p>
                  <h4
                    className="phone-number"
                    sx={{
                      mt: 1,
                      wordBreak: "break-all",
                      whiteSpace: "nowrap",
                      fontSize: "16px !important",
                    }}
                  >
                    <a href={`mailto:${currentCustomer?.email}`}>
                      {currentCustomer?.email}
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <ul className="list-unstyled shape-group-12">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="Circle"
              />
            </li>
          </ul>
        </div>

        <div className="section section-padding bg-color-dark overflow-hidden">
          <div className="container">
            <SectionTitle
              subtitle="Ubicación"
              title="Nuestra oficina"
              description=""
              textAlignment="heading-light-left"
              textColor=""
            />
            <div className="row">
              <ContactLocation />
            </div>
          </div>
          <ul className="shape-group-11 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
                alt="line"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="line"
              />
            </li>
          </ul>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default Contact;
